import {request_guarantee} from './state';
import {getApiDomain} from '../../../util/domains';
import moment from 'moment';

export function setContactWarehouseIdRequestGuarantee(state, user_b2b) {
    state.request_guarantee.contact_id = user_b2b.contact_id;
    state.request_guarantee.contact_warehouse_id = user_b2b.id;
}

export function setContactWarehouseIdRequestGuaranteeFilters(state, contact_warehouse_id) {
    state.filters.contact_warehouse_id = contact_warehouse_id;
}

export function setModalShow(state, modal_show) {
    state.modal.show = modal_show;
}

export function setStep(state, step) {
    state.step = step;

    let observation = '';

    const obj_step = state.steps.find(s => s.step === step);

    if (obj_step) {
        const _state = state.request_guarantee.request_guarantee_states.find(s => s.state.code_parameter === obj_step.code);

        if (_state) {
            observation = _state.observation;
        }
    }

    state.request_guarantee.observation = observation;
}

export function setStepAvailable(state, step_available) {
    state.step_available = step_available;
}

export function setRequestsGuarantees(state, requests_guarantees) {

    requests_guarantees.data.map(rg => {
        let step = 1;
        let step_code = '';

        if (rg.request_guarantee_state && rg.request_guarantee_state.state) {
            step_code = rg.request_guarantee_state.state.code_parameter;

            let step_obj = state.steps.find(s => s.code === step_code);

            if (step_obj) {
                step = step_obj.step;
            }
        }

        rg.only_view = step > 1 || step_code === 'PGS9' || step_code === 'PGS5';
    });


    state.requests_guarantees = requests_guarantees;
}

export function setRequestGuarantee(state, request_guarantee) {

    const state_creation = request_guarantee.request_guarantee_states.find(s => s.state.code_parameter === 'PGS1');

    if (state_creation) {
        request_guarantee.observation = state_creation.observation;
    }

    state.request_guarantee = request_guarantee;
    state.request_guarantee.attachments_deleted = [];
}

export function resetRequestGuarantee(state) {
    state.request_guarantee = request_guarantee();
}

export function setAction(state, action) {
    state.action = action;
}

export function addAttachmentDeleteRequestGuarantee(state, attachment) {
    state.request_guarantee.attachments_deleted.push(attachment);
}

export function deleteAttachmentRequestGuarantee(state, attachment) {
    let keys = [
        'images_product',
        'other_images',
        'images_guide'
    ];

    let request_guarantee = JSON.parse(JSON.stringify(state.request_guarantee));

    keys.map(key => {
        let index_attachment = request_guarantee[key].findIndex(a => a.id === attachment.id);

        if (index_attachment >= 0) {
            request_guarantee[key].splice(index_attachment, 1);
        }
    });

    state.request_guarantee = request_guarantee;
}

export function resetPageFilters(state) {
    state.filters.page = 1;
}

export function setSending(state, sending) {
    state.sending = sending;
}


export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable documents.
 */
export function setDocuments(state, documents) {
    state.documents = documents;
}

/**
 * Establecer un valor para la variable request_types.
 */
export function setRequestTypes(state, request_types) {
    state.request_types = request_types;
}

/**
 * Establecer un valor para la variable devolution_reasons.
 */
export function setDevolutionReasons(state, devolution_reasons) {
    state.devolution_reasons = devolution_reasons;
}

/**
 * Establecer un valor para la variable model.
 */
export function setModel(state, model) {
    state.model = model;
}

export function setUpdateDocumentValues(state, data) {
    state.request_guarantee.return.total_value = data.total_value;
    state.request_guarantee.return.total_value_brut = data.total_value_brut;
    state.request_guarantee.return.taxes = data.taxes;
}

/**
 * Establecer un valor para el atributo show de la variable modal_pdf.
 */
export function setShowToModalPdf(state, document) {
    state.modal_pdf.pdf = getApiDomain() + document.invoice_link;
    state.modal_pdf.show = true;
}

/**
 * Establecer un valor para la variable approval_states.
 */
export function setApprovalStates(state, approval_states) {
    state.approval_states = approval_states;
}

/**
 * Establecer un valor para la variable approval_reasons.
 */
export function setApprovalReasons(state, approval_reasons) {
    state.approval_reasons = approval_reasons;
}

/**
 * Establecer un valor para la variable options.
 */
export function setOptions(state, options) {
    state.options = options;
}

/**
 * Establecer un valor para la variable branch_offices.
 */
export function setBranchOffices(state, branch_offices) {
    state.branch_offices = JSON.parse(localStorage.getItem('branchoffices'));
}

/**
 * Establecer un valor para la variable branch_offices_warehouses.
 */
export function setBranchOfficesWarehouses(state, branch_offices_warehouses) {
    state.branch_offices_warehouses = JSON.parse(localStorage.getItem('branchoffices_warehouses'));
}

/**
 * Establecer un valor para la variable documents_by_thread.
 */
export function setDocumentsByThread(state, documents_by_thread) {

    documents_by_thread.map(d => {
        d.unix = moment(d.document_date).unix()
    })

    documents_by_thread = documents_by_thread.sort((a,b) => a.unix - b.unix)

    state.documents_by_thread = documents_by_thread;
}

/**
 * Establecer un valor para la variable models.
 */
export function setModels(state, models) {
    state.models = models;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable guarantee_reasons.
 */
export function setGuaranteeReasons(state, guarantee_reasons) {
    state.guarantee_reasons = guarantee_reasons;
}



// WEBPACK FOOTER //
// ./src/b2b/modules/guarantees/mutations.js